module.exports = __webpack_public_path__ + "img/left_bgc.958c1042.png";